import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Toast, BasicAuthLogout, HistoryListener } from '@phishtool/ui';
import { StyledPageWrapper } from './styled';
const Page = ({ children }) => (_jsxs(_Fragment, { children: [_jsx(HistoryListener, {}), _jsx(BasicAuthLogout, {}), _jsx(Toast, { position: 35 }), _jsx(StyledPageWrapper, { children: children })] }));
export default Page;
